import { __awaiter } from "tslib";
import { FETCH_SUPPLIERS } from '../constants/Urls';
import { http } from './api';
export const fetchSuppliers = (dispatch, paginated) => __awaiter(void 0, void 0, void 0, function* () {
    return http
        .get(`${FETCH_SUPPLIERS}${paginated ? `?skip=${(paginated === null || paginated === void 0 ? void 0 : paginated.skip) || 0}&limit=${paginated.limit || 0}` : ''}`);
});
